import dynamic from 'next/dynamic';

export default dynamic(() => import('./useSentry'), {
    ssr: false,
});
